import { AxiosError } from "axios";

export type ApiErrorPayload = { message: string; code?: string };

/** Reads ASP.NET BadRequest shapes: { error, code } or { message }. */
export function getApiErrorPayload(err: unknown): ApiErrorPayload | null {
  if (!err || typeof err !== "object") {
    return null;
  }
  if (!("isAxiosError" in err) || !(err as AxiosError).isAxiosError) {
    return null;
  }
  const ax = err as AxiosError<{ message?: string; error?: string; code?: string }>;
  const d = ax.response?.data;
  if (!d || typeof d !== "object") {
    return null;
  }
  const message =
    typeof d.error === "string" ? d.error : typeof d.message === "string" ? d.message : null;
  if (!message) {
    return null;
  }
  const code = typeof d.code === "string" ? d.code : undefined;
  return { message, code };
}
